<template>
  <div class="admin_home">
    <PayrollHeader />
    <div class="content">
      <div class="page-loader" v-if="pageLoading">
        <div>
          <PageLoader />
        </div>
      </div>
      <div class="payroll__setting" v-if="!pageLoading">
        <p>hrdesk Setup</p>
        <div>
          <div class="payroll__setting--nav">
            <div class="payroll__setting--nav-first">
              <div>
                <font-awesome-icon icon="check" />
              </div>
              <p>Step 1</p>
            </div>
            <div class="payroll__setting--nav-line"></div>
            <div class="payroll__setting--nav-last">
              <div></div>
              <p>Step 2</p>
            </div>
          </div>
        </div>

        <div>
          <div class="payroll__setting--desc">
            <div>
              <img src="./../../../assets/images/illo.png" alt="setup" />
            </div>
            <p>
              Let's setup your company payroll settings
            </p>
          </div>
        </div>

        <div>
          <div class="payroll__setting--card">
            <div class="payroll__setting--card-container">
              <div class="payroll__setting--left">
                <span
                  >1. What Time of The Month Do You Want To Run Payroll For Your
                  Company?</span
                >

                <div class="payroll__setting--date">
                  <div class="payroll__setting--date-left">
                    <select v-model="selectedDate">
                      <option v-for="date in days" v-bind:key="date.index">{{
                        date
                      }}</option>
                    </select>
                  </div>
                  <div class="payroll__setting--date-right">
                    <font-awesome-icon icon="calendar" />&nbsp;Payroll Run
                    Date
                  </div>
                </div>
              </div>
            </div>
            <div class="payroll__setting--card-container">
              <div class="payroll__setting--left">
                <p>1. Compensation:</p>
                <div class="payroll__setting--left-text">
                  Some default values have been added. You can go ahead to add
                  more values. Click
                  <a href="./demo" target="_blank">here</a> to see a preview of
                  a demo payroll
                </div>

                <div class="payroll__setting--left-alert">
                  <font-awesome-icon icon="bullhorn" />&nbsp;Funfact: when you
                  type, click enter and what you typed will appear above like
                  the other ones
                </div>
                <div class="payroll__setting--left-input">
                  <input
                    type="text"
                    placeholder="Type here to add more..."
                    v-model.trim="compensationValue"
                    @keyup.enter="addCompensation"
                  />
                </div>
              </div>
              <div class="payroll__setting--right">
                <div class="payroll__setting--left-section">
                  <div
                    v-for="(compensation, index) in compensations"
                    :key="index"
                  >
                    <div>
                      <div class="payroll__setting--left-section-name">
                        {{ compensation.name }}
                      </div>
                      <div
                        class="payroll__setting--left-section-close"
                        @click="removeItem(index, compensations)"
                        v-if="!hideCompensationDefaults(compensation)"
                      >
                        <font-awesome-icon icon="times-circle" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="payroll__setting--card-container">
              <div class="payroll__setting--left">
                <p>Deductibles:</p>
                <div class="payroll__setting--left-text">
                  Some default values have been added. You can go ahead to add
                  more values. Click
                  <a href="./demo" target="_blank">here</a> to see a preview of
                  a demo payroll
                </div>

                <div class="payroll__setting--left-alert">
                  <font-awesome-icon icon="bullhorn" />&nbsp;Funfact: when you
                  type, click enter and what you typed will appear above like
                  the other ones
                </div>
                <div class="payroll__setting--left-input">
                  <input
                    type="text"
                    placeholder="Type here to add more..."
                    v-model.trim="deductiblesValue"
                    @keyup.enter="addDeductibles"
                  />
                </div>
              </div>
              <div class="payroll__setting--right">
                <div class="payroll__setting--left-section">
                  <div v-for="(deductible, index) in deductibles" :key="index">
                    <div>
                      <div class="payroll__setting--left-section-name">
                        {{ deductible.name }}
                      </div>
                      <div
                        class="payroll__setting--left-section-close"
                        @click="removeItem(index, deductibles)"
                        v-if="!hideDeductibleDefaults(deductible)"
                      >
                        <font-awesome-icon icon="times-circle" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="payroll__setting--error">{{ dataSaveError }}</div>
            <div class="payroll__setting--error" v-if="successMsg">
              Payroll setting updated successfully.
            </div>
            <div class="payroll__setting--error" v-if="dateError">
              Please select a date for the next payment.
            </div>
            <div v-if="serverErrors">
              <p v-for="(value, name, index) in serverErrors" :key="index">
                {{ value[0] }}
              </p>
            </div>
            <div class="payroll__setting--btn" v-if="!loader" @click="saveData">
              Next
            </div>
            <div class="payroll__setting--btn" v-else>
              <WhiteLoader />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PayrollHeader from "../../partials/payrollHeader";
import WhiteLoader from "../../partials/white-loader";
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "setupPayroll",

  components: {
    PayrollHeader,
    WhiteLoader,
    PageLoader,
  },

  data() {
    return {
      loader: false,
      dateError: false,
      successMsg: false,
      networkError: false,
      days: [],
      selectedDate: "",

      loading: false,
      serverErrors: true,
      dataSaveError: " ",

      formData: {
        payroll_month: "",
      },

      compensations: [],

      deductibles: [],

      payables: [],

      payrollComponents: [],

      compensationValue: "",
      deductiblesValue: "",
      payablesValue: "",

      pageLoading: true,
    };
  },

  created() {
    this.getPayrollComponents();
  },

  methods: {
    hideCompensationDefaults(compensation) {
      return [
        "Basic",
        "Housing",
        "Transportation",
        "Reimbursement",
        "Net_pay",
      ].includes(compensation.name);
    },

    hideDeductibleDefaults(deductible) {
      return ["Pension", "Tax"].includes(deductible.name);
    },

    getPayrollComponents() {
      this.$http
        .get(types.GET_PAYROLL_COMPONENTS_API)
        .then((resp) => {
          const now = new Date();
          this.days = new Date(
            now.getFullYear(),
            now.getMonth() + 1,
            0
          ).getDate();

          const data = resp.data.data;
          for (let index = 0; index < data.length; index++) {
            if (data[index].type.trim().toLowerCase() === "compensation") {
              this.compensations.push(data[index]);
            }

            if (data[index].type.trim().toLowerCase() === "deductible") {
              this.deductibles.push(data[index]);
            }

            if (data[index].type.trim().toLowerCase() === "payable") {
              this.payables.push(data[index]);
            }
          }
          this.pageLoading = false;
        })
        .catch();
    },

    removeItem(index, arr) {
      arr.splice(index, 1);
    },

    addCompensation() {
      if (this.compensationValue) {
        if (
          ![
            "basic",
            "housing",
            "transportation",
            "reimbursement",
            "net_pay",
          ].includes(this.compensationValue.toLocaleLowerCase())
        ) {
          this.compensations.push({
            name: this.compensationValue,
            type: "Compensation",
          });
          this.compensationValue = "";
        }
      }
    },

    addDeductibles() {
      if (this.deductiblesValue) {
        if (!["pension", "tax"].includes(this.deductiblesValue.toLowerCase())) {
          this.deductibles.push({
            name: this.deductiblesValue,
            type: "Deductible",
          });
          this.deductiblesValue = "";
        }
      }
    },
    addPayables() {
      if (this.payablesValue) {
        this.payables.push({
          name: this.payablesValue,
          type: "Payable",
        });
        this.payablesValue = "";
      }
    },

    saveData() {
      this.serverErrors = null;

      this.dateError = false;
      this.successMsg = false;
      this.networkError = false;
      const payrollComponent = [];

      if (this.compensations.length !== 0) {
        for (
          let compValue = 0;
          compValue < this.compensations.length;
          compValue++
        ) {
          payrollComponent.push({
            name: this.compensations[compValue].name,
            type: this.compensations[compValue].type,
          });
        }
      }

      if (this.deductibles.length !== 0) {
        for (let dedValue = 0; dedValue < this.deductibles.length; dedValue++) {
          payrollComponent.push({
            name: this.deductibles[dedValue].name,
            type: this.deductibles[dedValue].type,
          });
        }
      }

      if (this.payables.length !== 0) {
        for (let payValue = 0; payValue < this.payables.length; payValue++) {
          payrollComponent.push({
            name: this.payables[payValue].name,
            type: this.payables[payValue].type,
          });
        }
      }

      if (!this.selectedDate) {
        this.dateError = true;
        return;
      }

      let user = this.$store.getters.currentAuthUser;

      this.loader = true;

      const payrollSetting = {
        company_id: user.employees.company_id,
        payroll_month: this.selectedDate++,
        payroll_components: payrollComponent,
      };

      this.$http
        .post(types.PAYROLL_SETTING_API, payrollSetting)
        .then(() => {
          this.$router.push("/onboardform");
        })
        .catch((err) => {
          this.loader = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css);

.content {
  padding-top: 35px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #fcfcfc;
  min-height: 600px;

  .page-loader {
    margin-top: 50px;

    > div {
      width: 55px;
      margin: auto;
    }
  }

  .payroll__content--image {
    width: 4.115vw;
    object-fit: contain;
    margin: 0 auto 36px auto;
    margin-bottom: 18px;
  }
  .text {
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
  }
  .fa-bullhorn {
    display: inline-flex;
    font-size: 12px;
    color: #f17d6b;
    margin-top: 10px;

    .danger {
      color: #f17d6b;
      margin-left: 10px;
    }
  }
  #input_time {
    input {
      position: relative;
    }
    i {
      position: absolute;
      top: 25.5em;
      left: 40.5em;
      color: #011;
    }
  }
  .form_fill {
    width: 900px;
    //height: 1245px;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    margin: 25px auto 36px auto;
    padding: 10px 2px 10px 10px;
    ol {
      li {
        color: #5099de;
        margin-top: 7em;
        font-size: 14px;
        font-weight: 500;
        .deductText {
          color: #000;
          margin-top: 15px;
          line-height: 2.4;
        }
        a {
          color: #5099de;
          font-weight: 600;
        }
        input {
          width: 370px;
          margin-top: 10px;
          padding: 10px;
          ::placeholder {
            opacity: 0.5;
          }
        }
      }
      li:first-child {
        margin-top: 2em;
        input {
          width: 170px;
          height: 30px;
          margin-top: 30px;
          border-radius: 2px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          padding: 12px;
        }
      }
    }
    .radio {
      width: 155px;
      height: 46px;
      border-radius: 20px;
      border: solid 1px #c7c7c7;
      background-color: #ffffff;
    }
    .endbutton {
      display: flex;
      width: 280px;
      margin-left: 43px;
      margin-top: 4em;
      margin-bottom: 6em;
      font-size: 14px;
      button {
        font-size: 14px;
        padding: 6px;
      }
      .savebutton {
        background-color: #5099de;
        border: none;
        font-size: 14px;
      }
      .skipbutton {
        background-color: #fff;
      }
      .skipbutton:hover {
        border-color: #5099de;
        background-color: none;
        color: #5099de;
      }
      .skipbutton:focus {
        border-color: #5099de;
        background-color: none;
        color: #5099de;
      }
    }
    .flex-wrap {
      display: inline-block;
      width: 160px;
      padding-left: 4.3em;
      padding-top: 17px;
      .bg-transparent {
        border-radius: 20px;
        width: max-content;
        background-color: #fff;
        border: 1px solid #c7c7c7;
        padding: 7px 11px;
        opacity: 0.7;
        margin-bottom: 13px;

        i {
          margin-left: 5px;
          display: inline;
        }
      }
    }
  }
}

.payroll__setting {
  padding-bottom: 150px;
  overflow: hidden;
  max-width: 1000px;
  margin: auto;

  > span {
    > a {
      color: #000;
      font-size: 12px;
      text-decoration: none;
    }
  }

  > p {
    font-size: 25px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
  }

  > div {
    overflow: hidden;
    margin-bottom: 20px;

    > .payroll__setting--nav {
      width: 300px;
      margin: auto;
      overflow: hidden;

      > .payroll__setting--nav-first {
        width: 40px;
        float: left;

        > div {
          width: 40px;
          height: 40px;
          border: solid 2px #5099de;
          border-radius: 60px;
          background-color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          color: #5099de;
        }

        > p {
          font-size: 10px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.3;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          margin-top: 5px;
        }
      }

      > .payroll__setting--nav-line {
        width: calc(100% - 80px);
        height: 2px;
        border: solid 1px #5099de;
        float: left;
        margin-top: 20px;
      }

      > .payroll__setting--nav-last {
        width: 40px;
        float: left;

        > div {
          width: 40px;
          height: 40px;
          border: solid 2px #5099de;
          border-radius: 60px;
          background-color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          color: #5099de;
        }

        > p {
          font-size: 10px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.3;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          margin-top: 5px;
        }
      }
    }

    > .payroll__setting--desc {
      width: 250px;
      margin: auto;

      > div {
        width: 40px;
        margin: auto;
      }

      > p {
        font-size: 20px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        margin-top: 20px;
      }
    }

    > .payroll__setting--card {
      border: solid 0.5px #f3f3f3;
      background-color: #ffffff;
      padding: 20px;
      overflow: hidden;

      @media (max-width: 500px) {
        padding: 10px;
      }

      > .payroll__setting--card-container {
        overflow: hidden;
        padding: 20px 0;
        border-bottom: 1px solid #f3f3f3;

        > .payroll__setting--left {
          width: 50%;
          float: left;

          @media (max-width: 1000px) {
            width: 100%;
          }

          > p {
            font-size: 15px;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: left;
            color: #5099de;
          }

          > span {
            font-size: 16px;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: left;
            color: #5099de;
          }

          .payroll__setting--date {
            margin-top: 30px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: center;
            align-content: center;

            @media (max-width: 400px) {
              flex-direction: column;
            }

            > .payroll__setting--date-left {
              width: 150px;
              height: 40px;
              border-radius: 2px;
              border: solid 1px #c7c7c7;
              background-color: #ffffff;
              overflow: hidden;

              > select {
                width: 100%;
                height: 40px;
                font-size: 14px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.67;
                letter-spacing: normal;
                text-align: left;
                color: #5099de;
                border: 0;
                outline: 0;
                padding: 0 25px;
              }
            }

            .payroll__setting--date-right {
              font-size: 16px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 2.22;
              letter-spacing: normal;
              text-align: left;
              color: #777777;
              padding-left: 20px;

              @media (max-width: 400px) {
                padding-left: 0;
              }
            }
          }

          > .payroll__setting--left-text {
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.67;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            margin-bottom: 20px;

            > a {
              color: #5099de;
              text-decoration: none;
            }
          }

          > .payroll__setting--left-input {
            max-width: 600px;
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            overflow: hidden;

            > input {
              height: 40px;
              border: solid 1px #c7c7c7;
              background-color: #ffffff;
              font-size: 14px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 2.5;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
              padding: 10px;
              outline: 0;
              border: 0;
            }
          }

          .payroll__setting--left-alert {
            margin: 10px 0;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            letter-spacing: normal;
            text-align: left;
            color: #f17d6b;
          }

          // .payroll__setting--left-section {
          //   display: flex;
          //   flex-direction: row;
          //   flex-wrap: wrap;
          //   align-items: center;
          //   justify-content: flex-start;
          //   align-content: center;

          //   > div {
          //     width: 25%;
          //     padding-right: 20px;
          //     padding-bottom: 10px;

          //     @media (max-width: 600px) {
          //       width: 33.33333333%;
          //     }

          //     @media (max-width: 400px) {
          //       width: 50%;
          //     }

          //     > div {
          //       border-radius: 20px;
          //       border: solid 1px #caced5;
          //       background-color: #ffffff;
          //       height: 46px;
          //       font-size: 14px;
          //       font-weight: normal;
          //       font-style: normal;
          //       font-stretch: normal;
          //       line-height: 2.5;
          //       letter-spacing: normal;
          //       text-align: left;
          //       padding: 0 10px;
          //       display: flex;
          //       flex-direction: row;
          //       flex-wrap: nowrap;
          //       align-items: center;
          //       justify-content: space-between;
          //       align-content: center;
          //       color: #5099de;

          //       > .payroll__setting--left-section-name {
          //         width: 70%;
          //         text-align: left;
          //         overflow: hidden;
          //         white-space: nowrap;
          //         text-overflow: ellipsis;
          //       }

          //       > .payroll__setting--left-section-close {
          //         width: 30%;
          //         text-align: right;
          //         cursor: pointer;
          //       }
          //     }
          //   }
          // }
        }

        > .payroll__setting--right {
          width: 40%;
          float: right;
          padding: 43px 40px;

          @media (max-width: 1000px) {
            width: 100%;
            padding: 10px;
          }

          > p {
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 2;
            letter-spacing: normal;
            text-align: left;
            color: #5099de;
          }

          .payroll__setting--left-section {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-start;
            align-content: center;

            > div {
              width: 50%;
              max-width: 200px;
              padding-right: 20px;
              padding-bottom: 10px;

              > div {
                border-radius: 20px;
                border: solid 1px #caced5;
                background-color: #ffffff;
                height: 46px;
                font-size: 14px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 2.5;
                letter-spacing: normal;
                text-align: left;
                padding: 0 10px;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;
                align-content: center;
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

                > .payroll__setting--left-section-name {
                  width: 70%;
                  text-align: left;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  color: #777777;
                }

                > .payroll__setting--left-section-close {
                  width: 30%;
                  text-align: right;
                  cursor: pointer;
                  color: #777777;
                }
              }
            }
          }
        }
      }

      > .payroll__setting--error {
        height: 20px;
        font-style: italic;
        font-size: 13px;
        color: red;
        text-align: left;
        margin-top: 20px;
      }
      > .payroll__setting--error + div > p {
        font-style: italic;
        font-size: 13px;
        color: red;
        text-align: left;
      }

      > .payroll__setting--btn {
        width: 150px;
        height: 40px;
        border-radius: 5px;
        background-color: #5099de;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
        float: left;
        margin-right: 20px;
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
      }

      > .payroll__setting--cancel {
        width: 100px;
        color: #000;
        cursor: pointer;
        float: left;
        margin-top: 10px;

        > a {
          color: #000000;
          text-decoration: none;

          > div {
            width: 100%;
            border-radius: 5px;
            background-color: #dcdcdc;
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            padding: 12px 0;
          }
        }
      }
    }
  }
}
</style>
